'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var vuePropertyDecorator = require('vue-property-decorator');

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
(function(ContentEvent2) {
  ContentEvent2["LOAD_INIT"] = "contentLoadInit";
  ContentEvent2["LOAD_ERROR"] = "contentLoadError";
  ContentEvent2["LOAD"] = "contentLoad";
})(exports.ContentEvent || (exports.ContentEvent = {}));
exports.ContentMixin = class extends vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.contentLoadTimer = null;
    this.contentChunks = 0;
  }
  get contentIsLoading() {
    return this.contentChunks >= 0;
  }
  mounted() {
    this.childLoadInitListener = this.onChildLoadInit.bind(this);
    this.childLoadListener = this.onChildLoad.bind(this);
    this.childLoadErrorListener = this.onChildLoadError.bind(this);
    this.$el.addEventListener(exports.ContentEvent.LOAD_INIT, this.childLoadInitListener);
    this.$el.addEventListener(exports.ContentEvent.LOAD, this.childLoadListener);
    this.$el.addEventListener(exports.ContentEvent.LOAD_ERROR, this.childLoadErrorListener);
  }
  destroyed() {
    if (this.childLoadInitListener) {
      this.$el.removeEventListener(exports.ContentEvent.LOAD_INIT, this.childLoadInitListener);
    }
    if (this.childLoadListener) {
      this.$el.removeEventListener(exports.ContentEvent.LOAD, this.childLoadListener);
    }
    if (this.childLoadErrorListener) {
      this.$el.removeEventListener(exports.ContentEvent.LOAD_ERROR, this.childLoadErrorListener);
    }
  }
  onContentLoadInit() {
    if (this.contentLoadTimer) {
      clearTimeout(this.contentLoadTimer);
      this.contentLoadTimer = null;
    }
    if (this.contentChunks === 0) {
      this.handleContentLoadInit();
    }
    this.contentChunks++;
  }
  onContentLoad(content) {
    this.onContentChunkLoadEnd(content);
  }
  onContentLoadError(error) {
    this.onContentChunkLoadEnd();
    this.handleContentLoadError(error);
  }
  handleContentLoadInit() {
    return;
  }
  handleContentLoad(content) {
    return content;
  }
  handleContentLoadError(error) {
    if (error instanceof Error) {
      return error.message;
    }
    return error;
  }
  onChildLoadInit(event) {
    event.stopPropagation();
    this.onContentLoadInit();
  }
  onChildLoad(event) {
    event.stopPropagation();
    this.onContentLoad(event.detail[0]);
  }
  onChildLoadError(event) {
    event.stopPropagation();
    this.onContentLoadError(event.detail[0]);
  }
  onContentChunkLoadEnd(content) {
    this.contentChunks--;
    if (this.contentChunks === 0) {
      this.contentLoadTimer = setTimeout(() => {
        this.handleContentLoad(content);
      }, 100);
    }
  }
};
__decorateClass([
  vuePropertyDecorator.Emit("contentLoadInit")
], exports.ContentMixin.prototype, "handleContentLoadInit", 1);
__decorateClass([
  vuePropertyDecorator.Emit("contentLoad")
], exports.ContentMixin.prototype, "handleContentLoad", 1);
__decorateClass([
  vuePropertyDecorator.Emit("contentLoadError")
], exports.ContentMixin.prototype, "handleContentLoadError", 1);
exports.ContentMixin = __decorateClass([
  vuePropertyDecorator.Component
], exports.ContentMixin);
